module.exports = __webpack_public_path__ + "img/product18.7b0c1d23.png";